import { ParagraphText } from "../../../../Libraries";
import { formatNum } from "../../../../oscar-pos-core/constants";
import { Box } from "@mui/material";
import withObservables from "@nozbe/with-observables";
import { Fragment, useContext, useMemo } from "react";
import { LanguageContext } from "../../../../context/LanguageContext";
import { catchError, of, switchMap } from "rxjs";
import { ListTableAmountCell } from "../../../common";
import SidebarBodyContent from "../../../common/UBRightSidebar/SidebarBodyContent";
import { analytics, triggerLogEvent } from "../../../../config/firebase";
import { useNavigate } from "react-router-dom";
import { dateFormatInNumberWithSpace, formattedDateWithSpaceAndTime } from "../../../../utils";

const ItemList = ({
  item,
  key,
  balance,
  onSelect = () => {},
  index,
  ordersCount,
  handleOpenModal,
  openTransactionSidebar,
  setOpenTransactionSidebar,
  txnsDetail,
  type,
  isAppliedFilter,
}) => {
  const [I18n] = useContext(LanguageContext);
  const navigate = useNavigate();

  const isDisabled =
    item?.invoice?.id ||
    item?.txns?.id ||
    item?.wallet_txns?.id ||
    item?.external_type ||
    type?.toLowerCase() == "community"
      ? true
      : false;

  const handleEditTransaction = () => {
    triggerLogEvent(analytics, "acc_txn_edit_btn");
    navigate(`/Accounts/TransactionForm/Edit/${item?.id}`);
  };

  const customerInfoData = useMemo(
    () => [
      {
        title: I18n.date,
        value: item?.transacted_at
          ? formattedDateWithSpaceAndTime(item?.transacted_at)
          : "-",
      },
      {
        title: I18n.notes,
        value: item.udhaar_note || "-",
      },
    ],
    [item, I18n],
  );

  const detailsContent =
    item?.items?.length || Boolean(ordersCount) || item?.udhaar_note ? (
      <span>
        {item?.items?.length
          ? item?.items?.length
          : Boolean(ordersCount) && `${ordersCount} ${I18n.item}`}{" "}
        {item?.udhaar_note && (
          <>
            {Boolean(ordersCount) ? `(${item.udhaar_note})` : item.udhaar_note}
          </>
        )}
      </span>
    ) : (
      "-"
    );

  const balanceAmount =
    (balance && Object.keys(balance)?.length) || item?.balance
      ? formatNum(Math.abs(item?.balance || balance[item?.id]))
      : formatNum(0);

  return (
    <Fragment>
      <Box
        id={`txn_${index}`}
        className="invoiceListTableBody AccountItemListWrapper"
        key={key}
        onClick={(e) => {
          e.stopPropagation();
          setOpenTransactionSidebar(true);
          onSelect(item);
        }}
      >
        <Box
          className={`invListTableHeaderCol fiveColumn textLeft sidebarOption`}
        >
          <ParagraphText className="fontSize14 fontWeight400 truncateOneLine textLeft newFontColor">
            {item?.transacted_at
              ? dateFormatInNumberWithSpace(item.transacted_at)
              : "-"}
          </ParagraphText>
        </Box>

        <Box className={`invListTableHeaderCol fiveColumn textLeft`}>
          <ParagraphText className="fontSize14 fontWeight400 truncateOneLine textLeft newFontColor accountDetailDetailCol">
            {detailsContent}
          </ParagraphText>
        </Box>

        {isAppliedFilter ? null : (
          <Box
            className={`invListTableHeaderCol fiveColumn textRight amountColumnNewWrapper`}
          >
            <ListTableAmountCell amountWrapperClassName="newFontColor">
              Rs. {balanceAmount}
            </ListTableAmountCell>
          </Box>
        )}

        <Box
          className={`invListTableHeaderCol fiveColumn textRight amountColumnNewWrapper`}
        >
          {item.payment_mode === "Jama" ? (
            <ListTableAmountCell amountWrapperClassName="foundationGreenColor">
              Rs. {formatNum(item.amount)}
            </ListTableAmountCell>
          ) : (
            <ParagraphText className="fontSize14 fontWeight400 textRight newFontColor" />
          )}
        </Box>

        <Box
          className={`invListTableHeaderCol fiveColumn textRight amountColumnNewWrapper`}
        >
          {item.payment_mode === "Udhaar" ? (
            <ListTableAmountCell amountWrapperClassName="foundationOrangeColor">
              Rs. {formatNum(item.amount)}
            </ListTableAmountCell>
          ) : (
            <ParagraphText className="fontSize14 fontWeight400 textRight newFontColor" />
          )}
        </Box>
      </Box>
      {openTransactionSidebar && txnsDetail?.id == item.id ? (
        <Box onClick={(e) => e.stopPropagation()}>
          <SidebarBodyContent
            isCustomerTransaction={true}
            open={openTransactionSidebar}
            onClose={setOpenTransactionSidebar}
            quickSale={txnsDetail}
            handleDelete={handleOpenModal}
            handleEdit={handleEditTransaction}
            customerInfoData={customerInfoData}
            isShowDeleteBtn={!isDisabled}
            isShowEditBtn={!isDisabled}
          />
        </Box>
      ) : null}
    </Fragment>
  );
};

const enhance = withObservables(["item"], ({ item }) => ({
  ordersCount: item?.txns?.id
    ? item.txns.observe().pipe(
        switchMap((txns) => txns.orders.observeCount()),
        catchError((error) => of(null)),
      )
    : item?.invoice?.id
      ? item.invoice.observe().pipe(
          switchMap((invoice) => invoice.orders.observeCount()),
          catchError((error) => of(null)),
        )
      : item.orders
        ? item.orders.observeCount()
        : of(0),
}));

export default enhance(ItemList);
